import '../styles/application_tab.css'
